<template>
  <div class="w-100">
    <div class="navbar-container d-flex content align-items-center">
      <ul
        v-if="selectedProject"
        class="nav navbar-nav d-xl-none"
      >
        <li class="nav-item">
          <b-link
            class="nav-link"
            @click="toggleVerticalMenuActive"
          >
            <img
              :src="require('@/assets/svg/menu-icon.svg')"
              alt="menu-icon"
            >
          </b-link>
        </li>
      </ul>

      <b-link
        v-if="isNavMenuHidden"
        class="navbar-brand"
        :to="{ name: 'organization' }"
      >
        <b-img
          class="brand-logo"
          :src="appLogoImage"
          alt="logo"
        />
      </b-link>

      <template v-if="!isNavMenuHidden">
        <app-breadcrumb class="breadcrumbs" />

        <a
          class="d-flex flex-fill d-xl-none"
          :class="visible ? null : 'collapsed'"
          :aria-expanded="visible ? 'true' : 'false'"
          aria-controls="collapse-1"
          size="sm"
          @click="visible = !visible"
        >
          <div class="breadcrumb-page_title">
            {{ $route.meta.pageTitle }}
          </div>
          <GjIcon
            class="arrow ml-auto"
            :class="visible ? 'active' : ''"
            name="ArrowDown"
          />
        </a>
      </template>

      <b-navbar-nav class="nav align-items-center ml-auto">
        <user-dropdown :key="$route.fullPath" />
      </b-navbar-nav>
    </div>
    <b-collapse
      id="collapse-1"
      v-model="visible"
      class="mb-1 mx-1 w-100 d-xl-none"
    >
      <b-breadcrumb>
        <b-breadcrumb-item
          v-for="item in $route.meta.breadcrumb"
          :key="item.text"
          :active="item.active"
          :to="item.to"
          :disabled="item.disabled"
          @click="redirect(item.route)"
        >
          {{ item.text }}
        </b-breadcrumb-item>
      </b-breadcrumb>
    </b-collapse>
  </div>
</template>

<script>
import { BLink, BNavbarNav } from 'bootstrap-vue'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import UserDropdown from './components/UserDropdown.vue'

import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BLink,
    AppBreadcrumb,
    BNavbarNav,
    UserDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
    isNavMenuHidden: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
    }
  },
  computed: {
    selectedProject() {
      return this.$store.state.app.projectId !== null
    },
  },
  setup() {
    const { appLogoImage } = $themeConfig.app

    return { appLogoImage }
  },
  methods: {
    redirect(route) {
      if (route) {
        this.$router.push({
          name: route,
          params: { id: this.$route.params.id },
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@media (max-width: 1199px) {
  .breadcrumbs {
    display: none !important;
  }
}
.arrow {
  transform: rotate(0);
  transition: 0.4s ease;
  &.active {
    transform: rotate(180deg);
    transition: 0.4s ease;
  }
}

.brand-logo {
  width: 110px;
}
</style>
